import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { forkJoin, from, Observable, of } from 'rxjs';
import { delay, map, mergeMap } from 'rxjs/operators';
import { ImageToAdd } from './pdf-summary.model';

const PRINT_MARGIN = 10;
const PDF_PART_CLASS = "pdfPart"
const RECEIPT_PART_CLASS = "receiptPdfPart"

export class PdfSummaryService {

  generatePDF(images: ImageToAdd[]): Blob {
    const PDF = new jsPDF('p', 'mm', 'a4');
    let position = PRINT_MARGIN;
    const pageHeight = PDF.internal.pageSize.height;
    let page = 1;

    images?.slice().sort((a, b) => a.index - b.index)
      .forEach(image => {
        // adding page if image is too long, or for work hours
        if (position + image.fileHeight > pageHeight || image.index == 2) {
          PDF.addPage()
          page = page + 1;
          position = PRINT_MARGIN;
        }
        // add image to document
        PDF.addImage(image.uri, 'PNG', PRINT_MARGIN, position, image.fileWidth, image.fileHeight);
        // position for next image
        position = position + image.fileHeight + PRINT_MARGIN;
      });

    return PDF.output('blob');
  }

  generateImagesForPDF(): Observable<ImageToAdd[]> {

    const fileWidth = 210 - (PRINT_MARGIN * 2);

    return of("dummy").pipe(
      delay( 500 ), 
      mergeMap(_=>this.createCanvas()),
      map((canvas: HTMLCanvasElement[]) =>
        canvas.map((canva, index) => ({
          index: index + 1,
          // transform canva to image
          uri: canva.toDataURL('image/jpg',0.8),
          fileWidth,
          // define image height with same ratio as image width
          fileHeight: canva.height * fileWidth / canva.width
        }))
      ),
    )
  }

  private createCanvas(): Observable<HTMLCanvasElement[]> {
    const summarySteps = document.getElementsByClassName(PDF_PART_CLASS);
    const promiseArray = Array.from(summarySteps).map(elememt => html2canvas(elememt as HTMLElement));
    return forkJoin(...promiseArray);
  }

  generatePDFReceiptImage(): Observable<ImageToAdd> {

    const fileWidth = 210 - (PRINT_MARGIN * 2);
    const receiptStep = document.getElementsByClassName(RECEIPT_PART_CLASS);

    if (!receiptStep) { return of(null) }

    return from(html2canvas(receiptStep[0] as HTMLElement)).pipe(
      map(canva => ({
        index: 0,
        // transform canva to image
        uri: canva.toDataURL('image/png'),
        fileWidth,
        // define image height with same ratio as image width
        fileHeight: canva.height * fileWidth / canva.width
      }))
    )
  }

}